export const PROJECT_PURPOSE_TYPES = {
  BENCH: 'bench',
  DEFAULT_INTERNAL: 'default_internal',
  DELIVERY_PROJECT: 'delivery_project',
};

export const getPurposeName = (scope) => {
  switch (scope) {
      case PROJECT_PURPOSE_TYPES.BENCH:
          return 'Bench';
      case PROJECT_PURPOSE_TYPES.DEFAULT_INTERNAL:
          return 'Default Internal';
      case PROJECT_PURPOSE_TYPES.DELIVERY_PROJECT:
          return 'Delivery Project';
      default:
          return scope;
  }
};

// Check if advanced tabs/sections should be hidden based on project purpose
export const shouldHideAdvancedFeatures = (projectPurpose) => {
  if (!projectPurpose?.code) return false;
  const purposeCode = projectPurpose.code;
  return purposeCode === PROJECT_PURPOSE_TYPES.BENCH || purposeCode === PROJECT_PURPOSE_TYPES.DEFAULT_INTERNAL;
};